<template>
  <section>
    <!-- Listing Header -->
    <feed-header v-show="!isLoading" @search="search" @add="addFeedPost" />
    <div v-if="isLoading" class="custom-loading">
      <span><i class="fas fa-spinner fa-spin"></i> Loading...</span>
    </div>
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :isNoHeader="true"
        :value="feed"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <td :id="props.key">
            <feed-record
              :feedPost="props.row"
              @showImage="showImage"
              @playVideo="playVideo"
              @editFeed="modifyFeedPost(props.row)"
              @addComment="addComment"
              @editComment="modifyComment"
              @deleteFeed="removeFeedPost"
              @deleteComment="removeComment"
            />
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <!-- Listing Footer -->
    <feed-footer v-show="!isLoading" @search="search" />
    <!-- Dialogs -->
    <feed-dialog
      ref="feedModal"
      :show="actionFeedPost"
      @close="closeModal"
      @saved="savedFeedPost"
    />
    <comment-dialog
      ref="commentModal"
      :show="actionComment"
      @close="closeModal"
      @saved="savedComment"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
    <video-dialog ref="videoModal" :show="actionVideo" @close="closeModal" />
    <image-dialog :show="actionImage" @close="closeModal" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import FeedHeader from '@/Components/Feed/feed-header'
import FeedFooter from '@/Components/Feed/feed-footer'
import FeedDialog from '@/Components/Feed/forms/feed-dialog'
import CommentDialog from '@/Components/Feed/forms/comment-dialog'
import FeedRecord from '@/Components/Feed/feed-record'
import VideoDialog from '@/Components/Feed/forms/video-dialog'
import ImageDialog from '@/Components/Feed/forms/image-dialog'
export default {
  name: 'feed-listing',
  components: {
    ZTable,
    ConfirmRemove,
    FeedHeader,
    FeedFooter,
    FeedDialog,
    CommentDialog,
    FeedRecord,
    VideoDialog,
    ImageDialog,
  },
  data() {
    return {
      page: 1,
      actionFeedPost: null,
      actionComment: null,
      isLoading: false,
      itemId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Feed?',
      actionConfirmRemove: null,
      actionVideo: null,
      actionImage: null,
      removeWhat: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.setPager({
      name: 'page',
      value: 1,
    })
    await this.search()
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('feed', ['feed', 'feedPost', 'pager']),
    ...mapGetters('organizations', ['examineOrganization']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
        },
      ]
    },
  },
  methods: {
    ...mapActions('feed', [
      'resetFeed',
      'getFeed',
      'resetFeedPost',
      'resetFeedComment',
      'setPager',
      'deleteFeedPost',
      'deleteFeedComment',
    ]),
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        this.resetFeed()
        this.isLoading = true
        await this.$nextTick()
        await this.getFeed({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
          orgId: this.examineOrganization.id,
        })
        this.isLoading = false
        window.app.$forceUpdate()
        this.setIsRead()
      } catch (e) {
        console.log('Error', e)
      }
    },
    closeModal() {
      this.actionFeedPost = null
      this.actionComment = null
      this.actionVideo = null
      this.actionImage = null
      this.actionConfirmRemove = null
    },
    setIsRead() {
      let setRead = ''
      if (this.feed) {
        this.feed.forEach((element) => {
          if (element.read_by) {
            let read = element.read_by.split(' ')
            // console.log('Check Read By', {
            //   userId: this.profile.id,
            //   read_by: element.read_by,
            //   split: read,
            // })
            if (read.indexOf(this.profile.id.toString()) === -1) {
              if (setRead !== '') {
                setRead += ','
              }
              setRead += element.id
            }
          }
        })
      }
      if (setRead !== '') {
        console.log('Setting Read', setRead)
      }
    },
    showImage(url) {
      this.actionImage = url
    },
    playVideo(url) {
      let $this = this
      this.actionVideo = {
        url: url,
      }
      setTimeout(() => {
        $this.$refs.videoModal.showVideo()
      }, 250)
    },
    async savedComment() {
      this.actionComment = null
    },
    async addComment(post) {
      let data = {
        userId: this.profile.id,
        orgId: this.examineOrganization.id,
        feedId: post.id,
        comment: null,
      }
      this.resetFeedComment(data)
      this.actionComment = {
        isAdd: true,
        data: null,
      }
    },
    async modifyComment(comment) {
      let data = {
        userId: this.profile.id,
        orgId: this.examineOrganization.id,
        feedId: comment.message_id,
        comment: comment,
      }
      this.resetFeedComment(data)
      this.actionComment = {
        isAdd: false,
        data: comment,
      }
    },
    async savedFeedPost() {
      this.actionFeedPost = null
      await this.search()
    },
    async addFeedPost() {
      let data = {
        userId: this.profile.id,
        orgId: this.examineOrganization.id,
        feedPost: null,
      }
      this.$refs.feedModal.init()
      this.resetFeedPost(data)
      this.actionFeedPost = {
        isAdd: true,
        data: null,
      }
    },
    async modifyFeedPost(post) {
      let data = {
        userId: this.profile.id,
        orgId: this.examineOrganization.id,
        feedPost: post,
      }
      this.resetFeedPost(data)
      console.log('Editing Feed Post', post)
      this.actionFeedPost = {
        isAdd: false,
        data: data,
      }
      this.$refs.feedModal.setAttachments()
    },
    removeFeedPost(id) {
      this.itemId = id
      this.removeWhat = 'Feed'
      this.confirmQuestionRemove = 'Are you sure you wish to remove this Feed?'
      this.actionConfirmRemove = true
    },
    removeComment(id) {
      this.itemId = id
      this.removeWhat = 'Comment'
      this.confirmQuestionRemove =
        'Are you sure you wish to remove this Comment?'
      this.actionConfirmRemove = true
    },
    async performRemove() {
      this.actionConfirmRemove = null
      // Perform Removal
      if (this.removeWhat === 'Feed') {
        console.log('Deleting Feed Post', this.itemId)
        await this.deleteFeedPost(this.itemId)
        this.resetFeedPost({
          feedPost: null,
        })
        this.search()
      } else if (this.removeWhat === 'Comment') {
        console.log('Deleting Comment', this.itemId)
        await this.deleteFeedComment(this.itemId)
      }
      this.itemId = null
      this.removeWhat = null
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
.custom-loading {
  width: 100%;
  text-align: center;
}
</style>
